import React, { useEffect, useState } from "react";
import {
    Button, Dropdown, Menu, Collapse, Breadcrumb, Radio, Checkbox
} from "antd";
import {
    ArrowLeftOutlined, DownOutlined, PlusOutlined, CaretRightOutlined, CloseOutlined, HeartOutlined, UsergroupAddOutlined, DownloadOutlined, LoadingOutlined
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { activelyInterestedObj, consciouslyReceptiveObj, deepDiveColumns, highlyEngagedObj, subConsciouslyReceptiveObj, unAwareObj } from "../../../../config/TableColumns.config";
import { removeCategoryDeepDiveGroup, setListOfSubItems, setLowerLevelPerGroup, setMarketCategoryTypeToAdd, setResetDeepDiveActiveKeys, setSelectedInterestLevel, setSubItemsDataPerGroup, setTileSelected, setTileSelectedAll } from "../../../../store/components/Reports.slice";
import CustomLayout from "../../../General/CustomLayout/CustomLayout";
import { fDownloadLowerLevelCSV, fGetBehaviorMatchAndColor, fGetInterestLevel, fRenderShare, getAllKeywordsInFolder, getModuleCode, isDisplayTreeMap } from "../../../../utils/oneintelligence/OneIntelligenceHelper";
import DeepDiveCollapseHeader from '../../../General/DeepDiveCollapseHeader'
import ColumnFilter from "../../../General/ColumnFilter"
import CategoryDeepDiveContent from "./CategoryDeepDiveContent"
import Container from "../../../General/Container/Container"
import { BiGrid, BiMenu } from "react-icons/bi";
import CategoryDeepDiveTreeMap from "../CategoryDeepDiveTreeMap/CategoryDeepDiveTreeMap";
import CategoryDeepDiveSwitchDisplay from "./CategoryDeepDiveSwitchDisplay";
import ReportsServices from "../../../../services/Reports.services";
import { RiAiGenerate } from "react-icons/ri";
import { dynamicSort, isViewer } from "../../../../utils/MainHelper";
import { getWhiteLabelDictionary } from "../../../../utils/whitelabel/WhiteLabel.Helper";

const { Panel } = Collapse;
const columns = deepDiveColumns;
const filterInterestLevel = columns.filter((col) => col.filter === "behavior")

function CategoryDeepDive({
    data = [],
    loading,
    setBehaviouralSegmentData,
    setShowAddBehaviouralSegment
}) {
    const dispatch = useDispatch();
    const [listOfHiddenColumns, setlistOfHiddenColumns] = useState({});
    const [customLoading, setCustomLoading] = useState({})
    const [loadingDownloadLowerLevel, setLoadingDownloadLowerLevel] = useState({})
    const { listOfSubItems, subItemsDataPerGroup, resetDeepDiveActiveKeys, tilesSelected, lowerLevelPerGroup, selectedInterestLevel } = useSelector((state) => state.reports);
    const { displayMode } = useSelector((state) => state.treemapreports);
    const {
        countryNotAvailable
    } = useSelector((state) => state.buildTargets);
    const [selectAll, setSelectAll] = useState(false);
    const [numberOfAllItems, setNumberOfAllItems] = useState(0)

    const onChangeHiddenColumns = (params) => {
        const { value, group, key } = params;
        const newObj = {
            ...listOfHiddenColumns
        };
        if (!newObj[group]) newObj[group] = [];
        const currentList = newObj[group];

        if (!value && !currentList.includes(key)) {
            newObj[group].push(key);
        } else if (value && currentList.includes(key)) {
            newObj[group] = newObj[group].filter((k) => k !== key);
        }
        setlistOfHiddenColumns(newObj);
    };

    const { filteredColumns, filteredValues } = columns.reduce((acc, col) => {
        if (!col.type || col.type === "column") {
            acc.filteredColumns.push(col);
        } else {
            acc.filteredValues.push(col);
        }
        return acc;
    }, {
        filteredColumns: [],
        filteredValues: []
    });

    const [activeKeys, setactiveKeys] = useState(["empty"]);

    useEffect(() => {
        if (data.length) {
            let isLoading = data.filter((d) => d.loading !== undefined);
            if (!isLoading.length) isLoading = data.filter((d) => d.loadingSelectedTile !== undefined);
            if (isLoading.length) {
                const collapseEl = window.document.querySelector(".report--categorydeepdive .report--categorydeepdive--collapse");
                if (collapseEl) {
                    const items = Array.from(collapseEl.children);
                    const item = items[items.length - 1];
                    if (item) {
                        const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
                            const { top, left, bottom, right } = el.getBoundingClientRect();
                            const { innerHeight, innerWidth } = window;
                            return partiallyVisible
                                ? ((top > 0 && top < innerHeight) ||
                                    (bottom > 0 && bottom < innerHeight)) &&
                                ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
                                : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
                        };

                        if (!elementIsVisibleInViewport(item)) {
                            setTimeout(() => {
                                item.scrollIntoView({ behavior: "smooth", inline: "end", block: "nearest" });
                            }, 500);
                        }
                    }
                }
            }
        }
    }, [data.length]);

    useEffect(() => {
        const moduleCode = getModuleCode()
        if (data.length && ["globalwebindex", "customerbehavior"].includes(moduleCode)) {
            const tempObj = { ...lowerLevelPerGroup }
            data.forEach((d) => {
                if (d.discoveredCategory
                    && (d?.children || [])?.length
                    && !tempObj[d.discoveredCategory]
                ) {
                    dispatch(setLowerLevelPerGroup({
                        group: d.discoveredCategory,
                        subData: {
                            loading: true
                        }
                    }))
                    tempObj[d.discoveredCategory] = {
                        loading: true
                    }
                    const selectionsDetails = {}
                    const pathDetails = {}
                    const selections = {}
                    const getAllLastFolder = (items) => {
                        items.forEach((item) => {
                            const childList = item.tempChildren || item.children;
                            if (childList && childList.length) {
                                const [firstChild] = childList;
                                if (firstChild.children || firstChild.tempChildren) {
                                    return getAllLastFolder(childList)
                                } else {
                                    const childName = (item.name || item.item).toLocaleLowerCase();
                                    const childList = item.children || item.tempChildren;
                                    selections[childName] = childList ? getAllKeywordsInFolder(childList, []) : [childName];
                                    if (selectionsDetails[childName]) {
                                        selectionsDetails[childName].paths.push(item.namepath || item.path)
                                        pathDetails[item.namepath || item.path] = {
                                            ...item,
                                            paths: [item.namepath || item.path],
                                            children: undefined,
                                            tempChildren: undefined,
                                        }
                                    } else {
                                        selectionsDetails[childName] = {
                                            ...item,
                                            paths: [],
                                            children: undefined,
                                            tempChildren: undefined,
                                        }
                                    }
                                }
                            }
                        })
                    }
                    getAllLastFolder(d.tempChildren || d.children);

                    if (Object.values(selections).length) {
                        const { promise } = ReportsServices.getUsigDeepDive({
                            selections,
                            selectionsDetails,
                            masters: ReportsServices.getMasters(true),
                            category: { [d.discoveredCategory]: selections }
                        });

                        promise.then((response) => {
                            dispatch(setLowerLevelPerGroup({
                                group: d.discoveredCategory,
                                subData: {
                                    data: response.map((d) => {
                                        return {
                                            ...d,
                                            children: d.children.reduce((acc, child) => {
                                                try {
                                                    acc.push(child)
                                                    if (selectionsDetails[child.item.toLocaleLowerCase()].paths.length) {
                                                        selectionsDetails[child.item.toLocaleLowerCase()].paths.forEach((p) => {
                                                            if (pathDetails[p]) {
                                                                acc.push({
                                                                    ...child,
                                                                    path: p,
                                                                })
                                                            }
                                                        })
                                                    }
                                                } catch (error) {

                                                }
                                                return acc
                                            }, []).sort(dynamicSort("-score", true))
                                        }
                                    }),
                                    loading: false
                                }
                            }))
                        });
                    } else {
                        dispatch(setLowerLevelPerGroup({
                            group: d.discoveredCategory,
                            subData: {
                                data: d,
                                loading: false
                            }
                        }))
                        tempObj[d.discoveredCategory] = {
                            loading: false
                        }
                    }
                }
            })
        }
    }, [data, lowerLevelPerGroup])

    useEffect(() => {
        if (numberOfAllItems) {
            setSelectAll(numberOfAllItems === Object.values(tilesSelected).reduce((sum, item) => {
                return sum + item.length;
            }, 0))
        } else {
            setSelectAll(false)
        }
    }, [numberOfAllItems, tilesSelected])


    useEffect(() => {
        if (resetDeepDiveActiveKeys) {
            setactiveKeys(["empty"]);
            setResetDeepDiveActiveKeys(false);
        }
    }, [resetDeepDiveActiveKeys]);

    useEffect(() => {
        if (!window.sq.oneintel.isLoadedAnalysis) return;
        if (isViewer()) return;
        const keysOfSub = () => {
            const list = Object.keys(listOfSubItems);
            if (list.length) {
                setactiveKeys((prev) => [...prev, ...list.map((k) => data.find((d) => parseInt(d.group, 10) === parseInt(k, 10)).key)]);
            }
        };
        keysOfSub();
    }, [listOfSubItems]);

    const newTreeMap = isDisplayTreeMap()

    const onChangeFilterBehavior = ({ key, value }) => {
        dispatch(setSelectedInterestLevel({
            key, value, filterInterestLevel
        }))
    }
    const header = (
        <Container className="drow fullw justify-between">
            <Container className="dcol">
                <b className="report--title">Deep Dives</b>
                <p className="report--subtitle">
                    Here's a closer look at each category that's driving your audience engagements.
                </p>
            </Container>
            {!isViewer() && <Container className="drow align-center">
                <Checkbox checked={selectAll} disabled={loading} onChange={(e) => {
                    setSelectAll(e.target.checked)
                    if (e.target.checked) {
                        const filterData = data.reduce((acc, item) => {
                            const { showedValues } = listOfHiddenColumns[item.group]?.length
                                ? ({
                                    showedColumns: filteredColumns.filter((col) => (!listOfHiddenColumns[item.group].includes(col.key))),
                                    showedValues: filteredValues.filter((col) => (!listOfHiddenColumns[item.group].includes(col.key)))
                                })
                                : ({
                                    showedColumns: filteredColumns,
                                    showedValues: filteredValues
                                });

                            const subItemsData = subItemsDataPerGroup[item.group];

                            const summaryBehaviorMatch = {};
                            const toHideRowWithValue = showedValues.map((i) => i.key);
                            const filteredItem = { ...(subItemsData || item) };
                            filteredItem.group = item.group;
                            filteredItem.children = filteredItem.children.reduce((acc, i) => {
                                const newObj = {
                                    ...i,
                                    key: i.item,
                                    ...fGetBehaviorMatchAndColor(i.score),
                                    group: item.group
                                };

                                if (selectedInterestLevel.includes(newObj.behaviormatch)) return acc

                                if (!summaryBehaviorMatch[newObj.behaviormatch]) {
                                    summaryBehaviorMatch[newObj.behaviormatch] = {
                                        count: 1,
                                        behaviormatch: newObj.behaviormatch,
                                        color: newObj.color,
                                        bg: newObj.bg
                                    };
                                } else {
                                    summaryBehaviorMatch[newObj.behaviormatch].count += 1;
                                }

                                if (toHideRowWithValue.length) {
                                    if (toHideRowWithValue.includes(newObj.behaviormatch)) {
                                        acc.push(newObj);
                                    }
                                } else {
                                    acc.push(newObj);
                                }
                                return acc;
                            }, []);


                            if (!filteredItem.children.length && !(item.singleLoad ? !loading : (loading || item.loading || subItemsData?.loadingSub))) return acc

                            acc[filteredItem.key] = filteredItem.children.reduce((acc2, da) => {
                                if (!da.parent) {
                                    acc2.push({
                                        ...da,
                                        discoveredCategory: filteredItem.discoveredCategory,
                                        targetAudience: filteredItem.targetAudience
                                    });
                                }
                                return acc2;
                            }, [])
                            return acc
                        }, {})
                        setNumberOfAllItems(Object.values(filterData).reduce((sum, item) => {
                            return sum + item.length;
                        }, 0))
                        dispatch(setTileSelectedAll(filterData));
                    } else {
                        dispatch(setTileSelected({ removeAll: true }));
                    }

                }}>
                    Check All
                </Checkbox>
                <ColumnFilter
                    columns={filterInterestLevel}
                    hidden={selectedInterestLevel}
                    onChange={onChangeFilterBehavior}
                    label="Filter"
                    buttonProps={{
                        type: "link"
                    }}
                />
                {newTreeMap ? <>
                    <span style={{ color: "#CBD5E1", marginRight: "1mm" }}>|</span>
                    <CategoryDeepDiveSwitchDisplay />
                </> : null}
            </Container>}
        </Container>
    );

    const actionMenus = (item) => {
        const isLoadingDownloadLower = loadingDownloadLowerLevel[item.discoveredCategory]
        return {
            onClick: (e) => {
                e.domEvent.stopPropagation();
                if (e.key === "addbehaviouralsegments") {
                    setBehaviouralSegmentData(item);
                    dispatch(setMarketCategoryTypeToAdd("add"));
                    setShowAddBehaviouralSegment(true);
                } else if (e.key === "generatelowerlevel") {
                    if (lowerLevelPerGroup) {
                        try {
                            const { children } = lowerLevelPerGroup[item.discoveredCategory].data[0]
                            dispatch(setListOfSubItems({
                                ...item,
                                children,
                                item: "Lower Level",
                                showLowerLevel: true,
                                group: item.group
                            }));
                        } catch (error) {
                        }
                    }
                } else if (e.key === "downloadlowerlevel") {
                    // const selectionsDetails = {}
                    // const keywordsLevel = []
                    // const recurGetLast = (list = []) => {
                    //     list.forEach((child) => {
                    //         const children = child.children || child.tempChildren
                    //         if (children) {
                    //             const [firstChild] = children
                    //             const firstChildren = firstChild.children || firstChild.tempChildren
                    //             if (!firstChildren) {
                    //                 const text = (child.name || child.title).toLowerCase();
                    //                 selectionsDetails[text] = {
                    //                     ...child,
                    //                     path: child.namePath
                    //                 }
                    //                 keywordsLevel.push(child)
                    //             } else {
                    //                 recurGetLast(children)
                    //             }
                    //         }
                    //     })

                    // }
                    // recurGetLast(item.children);
                    // const tempSelections = keywordsLevel.reduce((acc, item) => {
                    //     const children = item.children || item.tempChildren
                    //     const text = (item.name || item.title).toLowerCase();
                    //     acc[text] = getAllKeywordsInFolder(children, [])
                    //     return acc
                    // }, {})

                    // const { promise } = ReportsServices.getUsigDeepDive({
                    //     selections: tempSelections,
                    //     selectionsDetails,
                    //     masters: ReportsServices.getMasters(),
                    //     category: { [item.discoveredCategory]: tempSelections }
                    // });
                    // setLoadingDownloadLowerLevel((prev) => {
                    //     return {
                    //         ...prev,
                    //         [item.discoveredCategory]: true
                    //     }
                    // })
                    // promise.then((response) => {
                    //     dispatch(setLowerLevelPerGroup({
                    //         group: item.discoveredCategory,
                    //         subData: response
                    //     }))
                    //     // fDownloadLowerLevelCSV(response, item.discoveredCategory)
                    //     setLoadingDownloadLowerLevel((prev) => {
                    //         return {
                    //             ...prev,
                    //             [item.discoveredCategory]: false
                    //         }
                    //     })
                    // });
                } else {
                    dispatch(removeCategoryDeepDiveGroup(item));
                }
            },
            items: [...(["globalwebindex"].includes(getModuleCode()) ? [{
                key: "generatelowerlevel",
                label: isLoadingDownloadLower ? "Generating..." : "Generate Microsegment Level",
                icon: isLoadingDownloadLower ? <LoadingOutlined /> : <RiAiGenerate />,
                disabled: !!listOfSubItems[item.group]?.length
            }] : []), {
                //     key: "downloadlowerlevel",
                //     label: isLoadingDownloadLower ? "Generating..." : "Generate Lower Level",
                //     icon: isLoadingDownloadLower ? <LoadingOutlined /> : <RiAiGenerate />,
                //     disabled: isLoadingDownloadLower
                // }, {
                key: "addbehaviouralsegments",
                label: "Add Behavioral Segments",
                icon: <PlusOutlined />
            }, {
                key: "removefromdashboard",
                label: "Remove from Dashboard",
                icon: <CloseOutlined />,
                danger: true
            }]
        }
    }
    return (
        <CustomLayout
            className="report--categorydeepdive"
            classNameHeader="report--categorydeepdive--header"
            classNameBody={"report--categorydeepdive--body d-flex-col flex-1" + newTreeMap ? displayMode : ""}
            style={{ width: "100%", height: "100%" }}
            header={header}
        >
            {(displayMode === "treemap" && newTreeMap) ?
                <CategoryDeepDiveTreeMap />
                :
                <Collapse
                    activeKey={activeKeys}
                    className="report--categorydeepdive--collapse"
                    expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                    onChange={(e) => {
                        setactiveKeys([...e, "empty"]);
                    }}
                >
                    {data.length
                        ? data.map((item) => {
                            const { showedColumns, showedValues } = listOfHiddenColumns[item.group]?.length
                                ? ({
                                    showedColumns: filteredColumns.filter((col) => (!listOfHiddenColumns[item.group].includes(col.key))),
                                    showedValues: filteredValues.filter((col) => (!listOfHiddenColumns[item.group].includes(col.key)))
                                })
                                : ({
                                    showedColumns: filteredColumns,
                                    showedValues: filteredValues
                                });
                            const showSub = listOfSubItems[item.group] && listOfSubItems[item.group].length;
                            const discoveredTitle = subItemsDataPerGroup[item.group]
                                ? subItemsDataPerGroup[item.group].discoveredCategory
                                : item.discoveredCategory;

                            const subItemsData = subItemsDataPerGroup[item.group];

                            const summaryBehaviorMatch = {};
                            const toHideRowWithValue = showedValues.map((i) => i.key);
                            const filteredItem = { ...(subItemsData || item) }
                            filteredItem.group = item.group;
                            filteredItem.children = filteredItem.children.reduce((acc, i) => {
                                const newObj = {
                                    ...i,
                                    key: i.item,
                                    ...fGetBehaviorMatchAndColor(i.score),
                                    group: item.group
                                };

                                if (selectedInterestLevel.includes(newObj.behaviormatch)) return acc

                                if (!summaryBehaviorMatch[newObj.behaviormatch]) {
                                    summaryBehaviorMatch[newObj.behaviormatch] = {
                                        count: 1,
                                        behaviormatch: newObj.behaviormatch,
                                        color: newObj.color,
                                        bg: newObj.bg
                                    };
                                } else {
                                    summaryBehaviorMatch[newObj.behaviormatch].count += 1;
                                }

                                if (toHideRowWithValue.length) {
                                    if (toHideRowWithValue.includes(newObj.behaviormatch)) {
                                        acc.push(newObj);
                                    }
                                } else {
                                    acc.push(newObj);
                                }
                                return acc;
                            }, []);

                            let share = fRenderShare(filteredItem.children);
                            if (["globalwebindex"].includes(getModuleCode()) && filteredItem?.summary?.size) {
                                share = filteredItem?.summary?.size
                            }
                            const itemPercent = fGetInterestLevel(filteredItem.children);
                            const itemStatus = fGetBehaviorMatchAndColor(itemPercent / 100);
                            const objCssSum = {
                                color: itemStatus.color,
                                backgroundColor: itemStatus.bg,
                                padding: ".5mm 1mm",
                                fontWeight: "500",
                                fontSize: "14px",
                                lineHeight: "22px"
                            };

                            if (!filteredItem.children.length && !(item.singleLoad ? !loading : (loading || item.loading || subItemsData?.loadingSub))) return null

                            const interestLevels = [
                                highlyEngagedObj.title,
                                activelyInterestedObj.title,
                                consciouslyReceptiveObj.title,
                                subConsciouslyReceptiveObj.title,
                                unAwareObj.title,
                            ]

                            const isLoadingItem = (() => {
                                if (item.singleLoad) return !loading
                                if (loading && filteredItem?.children?.length) return false
                                return (loading || item.loading)
                            })()

                            return (
                                <Panel
                                    className={`report--categorydeepdive--collapse--item ${itemStatus.behaviormatch}`}
                                    key={item.key}
                                    showArrow={!(showSub && !isViewer())}
                                    collapsible={showSub && !isViewer() ? "disabled" : ""}
                                    header={(
                                        <div className="d-flex-col gap-1">
                                            {showSub && !isViewer() ? (
                                                <Breadcrumb className="report--categorydeepdive--collapse--item--bread"
                                                    itemRender={(obj) => {
                                                        if (obj.key === "back") return <Button
                                                            disabled={subItemsData?.loadingSub}
                                                            className="report--categorydeepdive--collapse--bread--button"
                                                            type="text"
                                                            icon={<ArrowLeftOutlined />}
                                                            onClick={() => {
                                                                dispatch(setListOfSubItems({
                                                                    remove: true,
                                                                    group: item.group
                                                                }));
                                                                dispatch(setSubItemsDataPerGroup({
                                                                    row: { group: item.group },
                                                                    subData: null
                                                                }));
                                                                if (["globalwebindex"].includes(getModuleCode())) {
                                                                    setCustomLoading((prev) => {
                                                                        return {
                                                                            ...prev,
                                                                            [item.key]: true
                                                                        }
                                                                    })
                                                                    setTimeout(() => {
                                                                        setCustomLoading((prev) => {
                                                                            return {
                                                                                ...prev,
                                                                                [item.key]: false
                                                                            }
                                                                        })
                                                                    }, 1000)
                                                                }
                                                            }}
                                                        >
                                                            Back
                                                        </Button>
                                                        if (obj.key === "last") return <b className="fs-16 fw-600 c-bg-600">
                                                            {obj.title}
                                                        </b>
                                                        return <Button
                                                            disabled={subItemsData?.loadingSub}
                                                            className="report--categorydeepdive--collapse--bread--button"
                                                            type="text"
                                                            onClick={() => {
                                                                dispatch(setListOfSubItems({
                                                                    update: true,
                                                                    toUpdateIndex: obj.key,
                                                                    group: item.group
                                                                }));
                                                            }}
                                                        >
                                                            {obj.title}
                                                        </Button>
                                                    }}
                                                    items={[
                                                        { key: "back", label: "Back" },
                                                        ...listOfSubItems[item.group].map((bread, idx) => {
                                                            const title = bread.item.includes(":") ? bread.item.split(":")[1].trim() : bread.item
                                                            return {
                                                                title,
                                                                key: listOfSubItems[item.group][idx + 1] ? idx : "last"
                                                            }
                                                        })
                                                    ]
                                                    }>
                                                </Breadcrumb>
                                            ) : null}

                                            <div className="d-flex align-items-center" style={{ width: "100%" }}>
                                                {showSub && !isViewer()
                                                    ? null
                                                    : (
                                                        <span
                                                            className="report--categorydeepdive--number"
                                                            style={{ color: itemStatus.color }}
                                                        >
                                                            {item.group}
                                                        </span>
                                                    )}
                                                <DeepDiveCollapseHeader
                                                    discoveredCategory={discoveredTitle}
                                                    targetAudience={item.targetAudience}
                                                    loading={isLoadingItem}
                                                >
                                                    {/* {!activeKeys.includes(item.key) ? (
                                                    ) : null} */}
                                                    <div className="d-flex gap-2 align-items-start" style={{ whiteSpace: "nowrap" }}>
                                                        {share && (
                                                            <div className="d-flex align-items-center gap-1" key="summary-size">
                                                                <span className="d-flex gap-1-2 align-items-center text-bgray-500 fw-400">
                                                                    <UsergroupAddOutlined
                                                                        style={{
                                                                            fontSize: "14px",
                                                                            marginRight: "1mm"
                                                                        }}
                                                                    />
                                                                    Size:
                                                                </span>
                                                                <span style={objCssSum}>{share}</span>
                                                            </div>
                                                        )}
                                                        {(!isNaN(itemPercent)) && (
                                                            <div className="d-flex align-items-start gap-1" key="summary-interest">
                                                                <span className="d-flex gap-1-2 align-items-center text-bgray-500 fw-400">
                                                                    <HeartOutlined
                                                                        style={{
                                                                            fontSize: "14px",
                                                                            marginRight: "1mm"
                                                                        }}
                                                                    />
                                                                    Interest level:
                                                                </span>
                                                                {/* <span style={objCssSum}>
                                                                         {`${(itemPercent).toFixed(0)}% - ${itemStatus.behaviormatch}`}
                                                                     </span> */}
                                                                <div className="d-flex align-items-center gap-1 flex-wrap">
                                                                    {interestLevels.map((key) => {
                                                                        let BMList = summaryBehaviorMatch[key]
                                                                        if (["globalwebindex"].includes(getModuleCode()) && filteredItem?.summary?.summaryBehaviorMatch) {
                                                                            BMList = filteredItem?.summary?.summaryBehaviorMatch[key];
                                                                        }
                                                                        if (!BMList) return null
                                                                        return (
                                                                            <span
                                                                                key={BMList.behaviormatch}
                                                                                style={{
                                                                                    color: BMList.color,
                                                                                    backgroundColor: BMList.bg,
                                                                                    padding: ".5mm 1mm",
                                                                                    fontWeight: "500",
                                                                                    fontSize: "14px",
                                                                                    lineHeight: "22px"
                                                                                }}
                                                                            >
                                                                                {`${getWhiteLabelDictionary(BMList.behaviormatch, BMList.behaviormatch)} (${BMList.count})`}
                                                                            </span>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </DeepDiveCollapseHeader>

                                            </div>
                                        </div>
                                    )}
                                    extra={activeKeys.includes(item.key) ? (
                                        <div className="d-flex gap-1">
                                            {!isViewer() && (
                                                <Dropdown
                                                    disabled={isLoadingItem || countryNotAvailable}
                                                    menu={actionMenus(item)}
                                                >
                                                    <Button type="primary" onClick={(e) => { e.stopPropagation(); }}>
                                                        Actions
                                                        <DownOutlined />
                                                    </Button>
                                                </Dropdown>
                                            )}

                                            <ColumnFilter
                                                disabled={isLoadingItem}
                                                columns={columns}
                                                group={item.group}
                                                onChange={onChangeHiddenColumns}
                                                hidden={listOfHiddenColumns[item.group]}
                                            />
                                        </div>
                                    ) : null}
                                >
                                    <CategoryDeepDiveContent
                                        loading={!!(loading || customLoading[item.key])}
                                        share={share}
                                        data={filteredItem}
                                        interestLevel={itemPercent}
                                        itemStatus={itemStatus}
                                        columns={showedColumns}
                                        filteredValues={toHideRowWithValue}
                                        subItems={listOfSubItems[item.group]}
                                        setBehaviouralSegmentData={setBehaviouralSegmentData}
                                        setShowAddBehaviouralSegment={setShowAddBehaviouralSegment}
                                    />
                                </Panel>
                            );
                        })
                        : (
                            <Panel
                                className="report--categorydeepdive--collapse--item"
                                key="empty"
                                showArrow={false}
                                collapsible="disabled"
                                header={(
                                    <div className="d-flex align-items-center" style={{ width: "100%" }}>
                                        <span className="report--categorydeepdive--number">
                                            1
                                        </span>
                                        <DeepDiveCollapseHeader
                                            discoveredCategory={loading ? "Loading..." : ""}
                                            targetAudience={loading ? "Loading..." : ""}
                                        />
                                    </div>
                                )}
                                extra={(
                                    <div className="d-flex gap-1">
                                        <Dropdown disabled>
                                            <Button type="primary">
                                                Actions
                                                <DownOutlined />
                                            </Button>
                                        </Dropdown>
                                        <ColumnFilter
                                            disabled
                                            columns={[]}
                                        />
                                    </div>
                                )}
                            >
                                <CategoryDeepDiveContent loading={loading} />
                            </Panel>
                        )}
                </Collapse>}
        </CustomLayout>
    );
}

export default CategoryDeepDive;
